import { useClientVersionCheck } from "../hooks/useClientVersionCheck";

const ClientUpdateListener = () => {
  useClientVersionCheck({ notify: true });
  return null;
};

export default ClientUpdateListener;
